import { PayloadAction } from "@reduxjs/toolkit";
import { LookupTnState } from "../store/lookupTnSlice";

export function setLookupTnState(
  state: LookupTnState,
  action: PayloadAction<object[]>
) {
  state.data = action.payload;
}

export function setIsLoading(
  state: LookupTnState,
  action: PayloadAction<boolean>
) {
  state.isLoading = action.payload;
}
